/**
 * Takes a string and removes all letters, symbols
 * Returns only 0-9
 */
export const rmChars = (string: string) => string.replace(/[^\d]/g, "")
